import { ReactComponent as IconBurger } from "@common_assets/svg/menu-hamburger.svg"
import { IconButton } from "@mui/material"
import IconWrapper from "components/common/icon/iconWrapper"
import { useIsBreakpointUp } from "hooks/breakpoint"
import { useAppDispatch, useAppSelector } from "hooks/store"
import mixpanel from "mixpanel-browser"
import { useTranslation } from "react-i18next"
import { toggleIsMenuOpened } from "store/menu/menu.slice"
import { UserRole } from "ts/enums/User"
import { getAuthDataLocalStorage } from "utils/authData"

const Burger = () => {
  const dispatch = useAppDispatch()
  const isTablet = useIsBreakpointUp("tablet")
  const { t } = useTranslation()
  const isMenuOpened = useAppSelector((state) => state.menu.isMenuOpened)

  return (
    <IconButton
      aria-label={isMenuOpened ? t("layout.closeMenu") : t("layout.openMenu")}
      aria-expanded={isMenuOpened}
      sx={{ p: 0, mr: isTablet ? "28px" : "16px" }}
      onClick={() => {
        dispatch(toggleIsMenuOpened())
        if (getAuthDataLocalStorage()?.role === UserRole.TEACHER) {
          mixpanel.track("side_bar", {
            action: "open",
          })
        }
      }}
    >
      <IconWrapper>
        <IconBurger />
      </IconWrapper>
    </IconButton>
  )
}

export default Burger
